<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app-bar app
             :absolute="menuLocation === 'sidebar'"
             class="toolbar-full-width"
             :class="[toolbarConfig.height === 64 ? '' : 'custom-toolbar']"
             :color="isCloudTask ? 'ctLightBlue' : toolbarConfig.color"
             dark
             elevate-on-scroll
             :height="toolbarConfig.height"
             :fixed="menuLocation === 'toolbar'">
    <v-row :style="{ height: menuLocation === 'toolbar' || $route.name === 'Conversaciones' ? '100%' : '' }">
      <v-col cols="12" class="d-flex align-center pt-1 pb-0">
        <v-btn class="hidden-lg-and-up mr-3" icon @click="toggleSideBar()">
          <v-icon dark size="30px">mdi-menu</v-icon>
        </v-btn>

        <img :src="toolbarLogo"
             alt="App Logo"
             class="mr-2"
             :style="{ width: isCloudTask ? '120px' : '65px' }"
             v-if="menuLocation === 'toolbar' && $vuetify.breakpoint.lgAndUp" />

        <CompanyAppList v-if="$vuetify.breakpoint.mdAndUp"
                        :showChip="false"
                        :selectedCompany="selectedCompany"
                        :selectedApp="selectedApp" />

        <div class="mx-2 justify-end"
             style="min-width: 250px"
             :style="{ display: menuLocation === 'toolbar' && $vuetify.breakpoint.lgAndUp ? 'flex' : 'none' }">
          <SectionTitle :icon="toolbarConfig.icon"
                        :image="toolbarConfig.image"
                        :name="toolbarConfig.name"
                        small />
        </div>

        <div v-show="menuLocation === 'toolbar' && $vuetify.breakpoint.lgAndUp">
          <ToolbarMenu class="mx-2" />
        </div>

        <v-spacer/>

        <div v-show="menuLocation === 'sidebar' || (menuLocation === 'toolbar' && $vuetify.breakpoint.xlOnly)">
          <SupportChat />
        </div>

        <Language />

        <NotificationsMenu />

        <AppSettingsMenu />

        <PendingTaskMenu />

        <!--        <BalanceMenu v-if="isSuperAdmin || isAdmin || rolePayments"/>-->

        <AppUserMenu />
      </v-col>

      <v-col cols="12" class="d-sm-flex" :class="{ 'pt-0': menuLocation === 'toolbar' }">

        <div class="ml-4" v-show="$route.name !== 'Conversaciones' && menuLocation === 'sidebar'">
          <SectionTitle :icon="toolbarConfig.icon"
                        :image="toolbarConfig.image"
                        :name="toolbarConfig.name"
                        :small="menuLocation === 'toolbar'" />
        </div>

        <v-spacer/>

        <DateRangePicker class="mr-2"
                         v-model="toolbarDateRangeVisual"
                         v-if="$route.name === 'Superuser Home' || $route.name === 'Home'"
                         :showAllData="true">
        </DateRangePicker>

        <DatesRangePicker :color="toolbarConfig.color + ' darken-2'"
                          v-if="$route.name === 'ConversationMetrics'"
                          v-model="datesRange">
        </DatesRangePicker>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { EventBus } from '@/eventBus'
import AppSettingsMenu from '@/components/AppToolBar/AppSettingsMenu'
import AppUserMenu from '@/components/AppToolBar/AppUserMenu'
// import BalanceMenu from '@/components/AppToolBar/BalanceMenu'
import CompanyAppList from '@/components/widgets/list/CompanyAppList.vue'
import DatesRangePicker from '@/components/DatesRangePicker.vue'
import DateRangePicker from '@/components/ui/DateRangePicker'
import Language from '@/components/widgets/Language'
import NotificationsMenu from '@/components/AppToolBar/NotificationsMenu'
import ToolbarMenu from '@/components/AppToolBar/ToolbarMenu'
import SectionTitle from '@/components/AppToolBar/SectionTitle'
import SupportChat from '@/components/Support/SupportChat'
import PendingTaskMenu from '@/components/AppToolBar/PendingTaskMenu'
export default {
  components: {
    AppSettingsMenu,
    AppUserMenu,
    CompanyAppList,
    DateRangePicker,
    DatesRangePicker,
    Language,
    NotificationsMenu,
    PendingTaskMenu,
    SectionTitle,
    SupportChat,
    ToolbarMenu
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSuperAdmin']),
    ...mapState({
      administratorRoles: state => state.companies.administratorRoles,
      isCloudTask: state => state.auth.isCloudTask,
      menuLocation: state => state.graphicAspect.menuLocation,
      selectedCompany: state => state.companies.selectedCompany,
      selectedApp: state => state.apps.selectedApp
    }),
    rolePayments () {
      if (!this.administratorRoles) return false
      return this.administratorRoles.includes('ROLE_PAYMENTS')
    },
    toolbarDateRangeVisual: {
      get () {
        return this.$store.state.apps.toolbarDateRangeVisual
      },
      set (value) {
        this.$store.commit('SET_TOOLBAR_DATE_RANGE_VISUAL', value)
      }
    },
    datesRange: {
      get () {
        return this.$store.state.apps.datesRange
      },
      set (value) {
        this.$store.commit('SET_TOOLBAR_DATES_RANGE', value)
      }
    },
    toolbarLogo () {
      const cloudtaskLogo = 'https://storage.googleapis.com/keybe/cloudtask/cloudtask-logo-azul.svg'
      const kbLogo = 'https://storage.googleapis.com/keybe/images/kb-logos/kb-white2.png'
      return this.isCloudTask ? cloudtaskLogo : kbLogo
    }
  },
  watch: {
    toolbarDateRangeVisual (value) {
      let fromDate
      let toDate
      let allData
      if (value.allData) {
        allData = value.allData
      } else if (value.fromDate && value.toDate) {
        fromDate = value.fromDate
        toDate = value.toDate
      } else {
        // console.error('malformed date in daterangepickervisual watcher')
        return
      }

      this.$store.commit('SET_TOOLBAR_DATE_RANGE', { fromDate, toDate, allData })
    }
  },
  methods: {
    toggleDepositDialog (value) {
      this.$store.commit('TOGGLE_NEW_PAYMENT_DIALOG', value)
    },
    toggleSideBar () {
      EventBus.$emit('toggleSideBar')
    }
  },
  props: {
    toolbarConfig: {
      type: Object
    }
  }
}
</script>
<style lang="css" scoped>
  .custom-toolbar ::v-deep .v-toolbar__content {
    align-items: start !important;
  }
  #balanceChip >>> .v-chip__content {
    cursor: pointer;
  }
  #profileBtn .v-avatar {
    margin-right: 0;
  }
  #profileBtn .drpdwnProf {
    margin-left: 0;
  }
  #menuProfileOpt {
    z-index: 9 !important;
  }

  @media (max-width: 960px) {
    .toolbar-full-width {
      width: 100% !important;
    }
  }
</style>
